import React from "react";
import type { AppJsonConfig } from "../../types/config";

type Props = { links: NonNullable<AppJsonConfig["usefulLinks"]> | undefined };

const UsefulLinksSection: React.FC<Props> = ({ links }) => {
  return (
    <div className="psa-links-block">
      <div className="psa-links-title">Useful Links</div>
      <ul className="psa-links-list">
        {(links || []).map((l) => (
          <li key={l.url}>
            <a href={l.url} target="_blank" rel="noreferrer">{l.label}</a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default UsefulLinksSection;
